export const TASK_NAMES = {
	SEARCH_PAGE_FIRST_PARTY_CONFIG_UX: 'search-page/first-party-config-ux',
	SEARCH_PAGE_FIRST_PARTY_CONFIG_NETWORK: 'search-page/first-party-config-network',
	SEARCH_PAGE_THIRD_PARTY_CONFIG_UX: 'search-page/third-party-config-ux',
	SEARCH_PAGE_THIRD_PARTY_CONFIG_NETWORK: 'search-page/third-party-config-network',
	SEARCH_PAGE_COMBINED_CONFIG_UX: 'search-page/combined-config-ux',
	SEARCH_PAGE_COMBINED_CONFIG_NETWORK: 'search-page/combined-config-network',
	SEARCH_PAGE_FULL_PAGE_SEARCH_RESULTS_UX: 'search-page/full-page-search-results-ux',
	SEARCH_PAGE_FULL_PAGE_SEARCH_RESULTS_NETWORK: 'search-page/full-page-search-results-network',
	SEARCH_PAGE_FULL_PAGE_SEARCH_ASYNC_SEARCH_RESULTS:
		'search-page/full-page-search-async-search-results',
	QUICK_FIND_RECENT_ACTIVITIES_UX: 'quick-find/recent-activities-ux',
	QUICK_FIND_RECENT_ACTIVITIES_NETWORK: 'quick-find/recent-activities-network',
	QUICK_FIND_PRE_QUERY_RESULTS: 'quick-find/prequery-search-results-ux',
	QUICK_FIND_POST_QUERY_UX: 'quick-find/postquery-search-results-ux',
	QUICK_FIND_CONFLUENCE_ENTITIES_NETWORK: 'quick-find/confluence-entities-network',
	QUICK_FIND_CONFLUENCE_SPACES_NETWORK: 'quick-find/confluence-spaces-network',
	QUICK_FIND_LOOM_ENTITIES_NETWORK: 'quick-find/loom-entities-network',
	QUICK_FIND_JIRA_ISSUES_AND_TYPES_NETWORK: 'quick-find/jira-issues-and-types-network',
	QUICK_FIND_JIRA_ENTITIES_NETWORK: 'quick-find/jira-entities-network',
	QUICK_FIND_ATLAS_ENTITIES_NETWORK: 'quick-find/atlas-entities-network',
	QUICK_FIND_MERCURY_ENTITIES_NETWORK: 'quick-find/mercury-entities-network',
	QUICK_FIND_TALENT_ENTITIES_NETWORK: 'quick-find/talent-entities-network',
	QUICK_FIND_ASSETS_ENTITIES_NETWORK: 'quick-find/assets-entities-network',
	QUICK_FIND_INTENT_DETECTION_NETWORK: 'quick-find/intent-detection-network',
	QUICK_FIND_INTENT_DETECTION_UX: 'quick-find/intent-detection-ux',
} as const;
